
/* Consider using jsdoc comments on functions where the param type is not clear. This will help with intellisense.
https://docs.microsoft.com/en-us/visualstudio/ide/create-jsdoc-comments-for-javascript-intellisense?view=vs-2015
*/

import iOSController from './components/RunTime/iOSController';
import ArticleController from './components/RunTime/ArticleController';
//import EditorInfoController from './components/RunTime/EditorInfoController';
import LinkController from './components/RunTime/LinkController';
import LozadController from './components/RunTime/LozadController';
import ToggleSlideController from './components/RunTime/ToggleSlideController';
import ServiceWorkerController from './components/RunTime/ServiceWorkerController';
import ImageCreditsController from './components/RunTime/ImageCreditsController';
import UTMController from './components/RunTime/UTMController';

//runtime controllers
ArticleController.init();
//EditorInfoController.init();
iOSController.init();
LinkController.init();
LozadController.init();
ServiceWorkerController.init();
ToggleSlideController.init();
ImageCreditsController.init();
UTMController.init();
